module.exports = __webpack_public_path__ + "img/编组 2@2x (2).504f674d.png";